import React, { useState, useEffect } from 'react';
import { Users, UserPlus, 
  Phone, 
  Mail, 
  MapPin, 
  ArrowRight, 
  Star, 
    
  Award,
  Shield,
  Scale,
  FileText,
  Building,
  ExternalLink,
  ChevronRight,
  Clock,
  CheckCircle,
  Globe,
  Zap,
  Briefcase,
  Gavel,
  Heart,
  Target,
  TrendingUp,
  ShieldCheck,
  BookOpen,
  Lightbulb,
  Eye,
  Calendar,
  UserCheck,
  Building2,
  FileCheck,
  
  Crown,
  Trophy,
  CheckCircle2,
  HelpCircle,
  MessageSquare
} from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getLatestBlogPosts } from '../data/blogData';

const HomePage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [visibleSections, setVisibleSections] = useState({
    hero: false,
    about: false,
    services: false,
    testimonials: false,
    contact: false,
    certificates: false,
    team: false
  });

  useEffect(() => {
    setIsVisible(true);
    
    // Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.getAttribute('data-section');
          if (sectionId) {
            setVisibleSections(prev => ({
              ...prev,
              [sectionId]: true
            }));
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    // Observe all sections
    const sections = document.querySelectorAll('[data-section]');
    sections.forEach(section => observer.observe(section));

    return () => {
      sections.forEach(section => observer.unobserve(section));
    };
  }, []);

  const whatsappUrl = "https://wa.me/966115115945";

  // أبرز 3 خدمات
  const featuredServices = [
    {
      id: 1,
      icon: FileText,
      title: "صياغة العقود والمستندات القانونية",
      description: "نقدم خدمات صياغة العقود والمستندات القانونية باحترافية عالية",
      route: "/ContractDrafting",
      color: "from-[#0a3a23] to-[#0a3a23]",
      bgColor: "bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5"
    },
    {
      id: 2,
      icon: MessageSquare,
      title: "الاستشارات القانونية",
      description: "استشارات متخصصة في جميع المجالات القانونية مع فريق من الخبراء المعتمدين",
      route: "/LegalConsultation",
      color: "from-[#0a3a23] to-[#0a3a23]",
      bgColor: "bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5"
    },
    {
      id: 3,
      icon: Building,
      title: "تأسيس الشركات",
      description: "خدمات متكاملة لتأسيس وتسجيل الشركات بكافة أنواعها",
      route: "/Corporates",
      color: "from-[#0a3a23] to-[#0a3a23]",
      bgColor: "bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5"
    }
  ];

  // تجارب العملاء البارزة
  const featuredTestimonials = [
    {
      id: 1,
      platform: "Google Maps",
      content: "أخذت استشارة من عندهم عن طريق الواتساب، كانت مفيدة وساعدتني بالإضافة إلى أنها كانت مجانية.. تعامل رائع بارك الله فيكم ووفقكم المجهود يقدر، كل الشكر ...",
      rating: 5,
      platformIcon: "🗺️"
    },
    {
      id: 2,
      platform: "TikTok",
      content: "الله يسعدك يارب ومنها للأعلى ان شاء الله صراحه قمه في الرقي والاحترام المحامي انس ويوصلكم المعلومه بطريقه سلسه وبسيطه ويدعمكم معنوياً قبل اي شي الله يكثر من امثاله انصحكم فيه",
      rating: 5,
      platformIcon: "🎵"
    },
    {
      id: 3,
      platform: "Google Maps",
      content: "انصحكم في التعامل مع المحامي أنس الله يسعده ويرزقه انسان شاطر ولبق ومحترم الله يكثر من امثاله",
      rating: 5,
      platformIcon: "🗺️"
    }
  ];

  // إحصائيات المكتب
  const stats = [
    {
      icon: UserPlus,
      number: "500+",
      label: "عميل سعيد",
      description: "عملاء راضون عن الخدمات",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      icon: Award,
      number: "15+",
      label: "سنة خبرة",
      description: "خبرة واسعة في المجال القانوني",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      icon: CheckCircle,
      number: "99%",
      label: "معدل النجاح",
      description: "نسبة نجاح عالية في القضايا",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      icon: Clock,
      number: "24/7",
      label: "دعم مستمر",
      description: "خدمة متاحة على مدار الساعة",
      color: "from-[#0a3a23] to-[#0a3a23]"
    }
  ];

  // شهادات المكتب
  const certificates = [
    {
      icon: Shield,
      title: "معتمد لدى الهيئة السعودية للمحامين",
      description: "حصلت الشركة على ترخيص الإدارة العامة للمحاماة - وزارة العدل وعضوية المنشأة القانونية"
    },
    {
      icon: Award,
      title: "معتمد لدى الهيئة الملكية الفكرية",
      description: "شركة محاماة معتمدة لتسجيل العلامات التجارية والنماذج الصناعية وبراءات الإختراع"
    },
    {
      icon: UserPlus,
      title: "معتمد لدى وزارة الموارد البشرية",
      description: "شركة محاماة معتمدة لمراجعة واعتماد لوائح تنظيم العمل"
    }
  ];

  // لماذا نحن
  const whyChooseUs = [
    {
      icon: Globe,
      title: "خبرة محلية وفق المعايير العالمية",
      description: "نتميز بخبرة واسعة في القانون السعودي مع تطبيق المعايير الدولية"
    },
    {
      icon: Zap,
      title: "إدارة المشاريع القانونية إلكترونياً",
      description: "نستخدم أحدث التقنيات لإدارة المشاريع القانونية بكفاءة عالية"
    },
    {
      icon: Clock,
      title: "تقارير تلقائية في الوقت المحدد",
      description: "نقدم تقارير دورية ومحدثة عن سير العمل في المشاريع القانونية"
    }
  ];

  // خدمات إضافية
  const additionalServices = [
    {
      icon: FileText,
      title: "المتاجر الإلكترونية",
      description: "صياغة سياسات استخدام المواقع والمنصات الإلكترونية والتطبيقات وفقاً لقوانين المملكة"
    },
    {
      icon: Building,
      title: "قانون العمل",
      description: "إعداد لوائح تنظيم العمل والاستشارات القانونية في مجال العمل والعمال"
    },
    {
      icon: Globe,
      title: "العقود الدولية",
      description: "صياغة ومراجعة العقود والاتفاقيات الدولية باحترافية عالية"
    }
  ];



  // الأسئلة الشائعة
  const faqs = [
    {
      question: "كيف يمكنني حجز استشارة قانونية؟",
      answer: "يمكنك حجز استشارة قانونية من خلال الاتصال بنا مباشرة أو عبر الواتساب أو من خلال صفحة حجز الاستشارة في موقعنا."
    },
    {
      question: "ما هي تكلفة الخدمات القانونية؟",
      answer: "تختلف التكلفة حسب نوع الخدمة وتعقيد القضية. نقدم استشارة مجانية أولية لتقييم القضية وتحديد التكلفة."
    },
    {
      question: "هل تقدمون خدمات في جميع أنحاء المملكة؟",
      answer: "نعم، نقدم خدماتنا في جميع أنحاء المملكة العربية السعودية من خلال فروعنا المتعددة."
    },
    {
      question: "ما هي مدة إنجاز القضايا؟",
      answer: "تختلف مدة الإنجاز حسب نوع القضية وتعقيدها. نحرص على الإنجاز بأسرع وقت ممكن مع ضمان الجودة."
    }
  ];

  // العملاء والشركاء
  const clients = [
    {
      name: "شركة التقنية المتقدمة",
      logo: "/images/clients/tech-logo.png",
      type: "شركة تقنية",
      color: "from-blue-500 to-purple-600"
    },
    {
      name: "مجموعة العقارات المتحدة",
      logo: "/images/clients/realestate-logo.png",
      type: "شركة عقارية",
      color: "from-[#0a3a23] to-[#0a3a23]"
    },
    {
      name: "بنك التنمية السعودي",
      logo: "/images/clients/bank-logo.png",
      type: "مؤسسة مالية",
      color: "from-yellow-500 to-orange-600"
    },
    {
      name: "شركة النفط الوطنية",
      logo: "/images/clients/oil-logo.png",
      type: "شركة نفط",
      color: "from-red-500 to-pink-600"
    }
  ];

  const governmentLogos = [
    { src: "/images/Home/الدفاع_المدني_السعودي.svg.png", alt: "الدفاع المدني السعودي" },
    { src: "/images/Home/images (3).png", alt: "بلدي" },
    { src: "/images/Home/images (4).png", alt: "أجير" },
    { src: "/images/Home/unnamed.png", alt: "وزارة التجارة" },
    { src: "/images/Home/20231126120602!وزارة_الموارد_البشرية_والتنمية_الاجتماعية.png", alt: "وزارة الموارد البشرية" },
    { src: "/images/Home/images (1).png", alt: "أبشر" },
    { src: "/images/Home/The_Saudi_Ministry_of_Investment_-_logo.png", alt: "وزارة الاستثمار" },
    { src: "/images/Home/images (5).png", alt: "اعتماد" },
    { src: "/images/Home/82326.jpg", alt: "العنوان الوطني" },
    { src: "/images/Home/images (2).png", alt: "فسح" },
  ];

  // المدونات - تستخدم البيانات المشتركة مع تصحيح المحتوى
  const blogs = getLatestBlogPosts(3).map(post => {
    // تصحيح المحتوى حسب العنوان
    let correctedExcerpt = post.excerpt;
    
    if (post.title.includes("الاحتيال الإلكتروني")) {
      correctedExcerpt = "في عصر الرقمنة، بات الاحتيال الإلكتروني أحد أبرز الجرائم الحديثة.";
    } else if (post.title.includes("الابتزاز")) {
      correctedExcerpt = "يُعد الابتزاز من الجرائم التي تشكل خطراً على الأفراد والمجتمع وقد ازدادت حالاته في ظل انتشار وسائل التواصل الحديثة.";
    } else if (post.title.includes("الأدلة الرقمية")) {
      correctedExcerpt = "في السابق كان الإثبات يعتمد على الشهود والأوراق المكتوبة، لكن مع التطور التقني أصبحت التعاملات تتم إلكترونياً.";
    } else if (post.title.includes("عقود العمل")) {
      correctedExcerpt = "في عالم الأعمال المعاصر، يشكل عقد العمل حجر الأساس في تنظيم العلاقة بين صاحب العمل والموظف.";
    } else if (post.title.includes("التعديلات الجديدة في نظام العمل")) {
      correctedExcerpt = "تعرف على أحدث التعديلات في نظام العمل السعودي وتأثيرها على حقوق العاملين وأصحاب العمل.";
    } else if (post.title.includes("حماية المستهلك")) {
      correctedExcerpt = "تعرف على حقوق المستهلك الأساسية والأنظمة السعودية التي تحميه من الممارسات التجارية الضارة.";
    }
    
    return {
    title: post.title,
      excerpt: correctedExcerpt,
    date: post.date,
    image: post.image,
    route: post.path,
    readTime: post.readTime
    };
  });



  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-[#0a3a23]/10 to-[#0a3a23]/5" dir="rtl">
      
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div 
        data-section="hero"
        className={`relative min-h-screen flex items-center justify-center overflow-hidden transition-all duration-1000 mt-20 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat blur-sm"
          style={{ backgroundImage: "url('/images/Home/تصميم بدون عنوان - 2025-08-16T170838.419.png')" }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-20"></div>
        
        <div className={`relative z-10 w-full px-4 sm:px-6 text-white transition-all duration-1000 delay-300 ${visibleSections.hero ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex justify-center sm:justify-start w-full px-4 sm:pl-16 sm:pr-16 pt-20 sm:pt-32">
            <div className="max-w-2xl text-center sm:text-right">
              <div className="mb-6 sm:mb-8">
                <span className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm text-[#0a3a23] px-8 sm:px-10 py-5 sm:py-6 rounded-full text-xl sm:text-2xl font-bold shadow-lg">
                  <Award className="w-8 h-8 sm:w-10 sm:h-10" />
                  شركة أنس  عبد الرحمن خياط
                </span>
              </div>
              
              <h1 className="text-base sm:text-xl font-bold mb-4 sm:mb-6 leading-tight font-amiri">
                <span className="inline-flex items-center gap-3 bg-white/90 backdrop-blur-sm text-[#0a3a23] px-5 sm:px-7 py-3 sm:py-4 rounded-full text-base sm:text-xl font-bold shadow-lg">
                  <Award className="w-5 h-5 sm:w-6 sm:h-6" />
                  خبراء القانون الأكثر تميزاً
                </span>
              </h1>
              
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-6 sm:mb-8 text-white font-amiri drop-shadow-lg">
                في المملكة العربية السعودية
              </h2>
              
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white leading-relaxed mb-8 sm:mb-12 px-4 sm:px-0 font-medium drop-shadow-lg">
                نحرص على تقديم خدمات قانونية متكاملة، مدروسة، ومبنية على أسس شرعية ونظامية راسخة
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center sm:justify-start mb-12 sm:mb-16 px-4 sm:px-0">
                <a
                  href={`${whatsappUrl}?text=أريد استشارة قانونية`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-4 sm:px-6 py-3 sm:py-3 rounded-xl font-bold text-sm sm:text-base hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105"
                >
                  <WhatsAppIcon className="w-4 h-4 sm:w-5 sm:h-5 group-hover:animate-pulse" />
                  <span className="whitespace-nowrap">اطلب استشارة فورية</span>
                </a>
                
                <Link
                  to="/Services"
                  className="group inline-flex items-center justify-center gap-2 sm:gap-3 bg-white/90 backdrop-blur-sm text-[#0a3a23] px-4 sm:px-6 py-3 sm:py-3 rounded-xl font-bold text-sm sm:text-base hover:bg-white transition-all duration-300 border-2 border-white shadow-xl hover:shadow-2xl transform hover:scale-105"
                >
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
                  <span className="whitespace-nowrap">استكشف خدماتنا</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div 
        data-section="about"
        className="py-12 sm:py-20 bg-white"
      >
        

        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-16 items-start">
            <div className={`transition-all duration-1000 lg:order-1 ${visibleSections.about ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="mb-6 sm:mb-8">
                <span className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium">
                  <BookOpen className="w-3 h-3 sm:w-4 sm:h-4" />
                  نبذة تعريفية عن الشركة
                </span>
              </div>
              
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 sm:mb-8 font-amiri">
                شركة أنس عبد الرحمن خياط للمحاماة والاستشارات القانونية
              </h2>
              
              <div className="mb-6 sm:mb-8">
                <span className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full text-sm sm:text-base font-medium shadow-lg">
                  <MapPin className="w-4 h-4 sm:w-5 sm:h-5" />
                  مدينة جدة
                </span>
              </div>
              
              <div className="space-y-6 sm:space-y-8 text-sm sm:text-lg text-gray-700 leading-relaxed">
                <div className="bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl p-6 border border-[#0a3a23]/20 shadow-sm">
                  <p className="text-gray-800 font-medium text-base sm:text-lg">
                    تعتبر شركة أنس للمحاماة والاستشارات القانونية إحدى الشركات الرائدة في مجال المحاماة والاستشارات القانونية في المملكة العربية السعودية. وهي شركة مهنية مرخصة ومعتمدة من الجهات الحكومية واتخذت من جدة مقراً رئيسياً لإدارة أعمالها وتقديم خدماتها لجميع العملاء داخل المملكة العربية السعودية وخارجها.
                  </p>
                </div>
                
                <div className="space-y-4">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2 font-amiri">
                    <div className="w-2 h-2 bg-[#0a3a23] rounded-full"></div>
                    خدماتنا المميزة:
                  </h3>
                  <p className="text-gray-700 text-base sm:text-lg">
                    تقدم شركة أنس للمحاماة والاستشارات القانونية عدد من الخدمات القانونية لعملائها من الأفراد والشركات والمصانع والبنوك والجهات الحكومية، وتتميز الشركة بصياغة العقود والاتفاقيات وتعديلها، وتأسيس الشركات والكيانات وإدارة عمليات الاندماج والاستحواذ والإدراج في الأسواق المالية، وإصدار التراخيص الحكومية لكافة الأنشطة التجارية والصناعية والخدمية.
                  </p>
                </div>
                
                <div className="space-y-4">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2 font-amiri">
                    <div className="w-2 h-2 bg-[#0a3a23] rounded-full"></div>
                    خبرتنا الواسعة:
                  </h3>
                  <p className="text-gray-700 text-base sm:text-lg">
                    تتمتع الشركة بكفاءات مؤهلة في تقديم الخدمات القانونية، وبخبرة تراكمية تجاوزت 12 عام في مجال التقاضي والتحكيم وتقديم الاستشارات القانونية وصياغة العقود والاتفاقيات، وقيادة عمليات التفاوض والتسويات المالية والعينية، وتصفية الشركات والتركات، وتحصيل الديون والمستحقات، وابتكار الحلول الاستثمارية واستراتيجيات التنظيم المالي والإداري وإعادة الهيكلة، وتنظيم السياسات والمواثيق للشركات العائلية والكيانات الوقفية والجهات الربحية وغير الربحية.
                  </p>
                </div>
                
                <div className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] p-6 sm:p-8 rounded-2xl sm:rounded-3xl text-white shadow-lg">
                  <div className="flex items-start gap-4 sm:gap-6">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/20 rounded-2xl flex items-center justify-center flex-shrink-0">
                      <Lightbulb className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-300" />
                    </div>
                    <div>
                      <h4 className="text-xl sm:text-2xl font-bold mb-3 text-white font-amiri">هدفنا</h4>
                      <p className="text-white/90 text-base sm:text-lg leading-relaxed">
                        بناء علاقات طويلة الأمد مع عملائنا وتوفير أفضل الحلول لاحتياجاتهم القانونية والمؤسسية، مع التركيز على الابتكار والتميز في تقديم الخدمات القانونية المتكاملة
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 sm:mt-8">
                <Link
                  to="/About"
                  className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300 shadow-lg hover:shadow-xl text-sm sm:text-base"
                >
                  <span>اقرأ المزيد</span>
                  <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
                </Link>
              </div>
            </div>
            
            <div className={`relative transition-all duration-1000 delay-300 lg:order-2 ${visibleSections.about ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="relative lg:sticky lg:top-16 lg:mt-120 mt-20 lg:mt-40">
                {/* الصورة الأولى - كبيرة */}
                <div className="relative">
                                              <img
                              src="/images/صور الموقع (1)/1.jpg"
                              alt="شركة أنس للمحاماة - صورة 1"
                              className="rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl w-full h-96 sm:h-[28rem] object-cover"
                            />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl sm:rounded-3xl"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* شهادات الشركة */}
      <div 
        data-section="certificates"
        className="py-20 bg-white"
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className={`text-center mb-16 transition-all duration-1000 ${visibleSections.certificates ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="flex items-center justify-center gap-6 mb-6">
              <div className="relative group">
                <div className="w-16 h-16 bg-gradient-to-br from-[#0a3a23]/20 to-[#0a3a23]/10 rounded-2xl flex items-center justify-center shadow-sm group-hover:shadow-md transition-all duration-300 group-hover:scale-105 border border-[#0a3a23]/30">
                  <Award className="w-8 h-8 text-[#0a3a23] animate-pulse" />
                </div>
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-[#0a3a23]/40 rounded-full animate-pulse opacity-60"></div>
                <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-[#0a3a23]/30 rounded-full animate-pulse opacity-60"></div>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-amiri">
              شهادات الشركة
            </h2>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              نفتخر بحصولنا على اعتمادات رسمية من أهم الهيئات والوزارات
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {certificates.map((cert, index) => (
              <div 
                key={index} 
                className="bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group"
              >
                <div className="w-20 h-20 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <cert.icon className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 font-amiri">{cert.title}</h3>
                <p className="text-gray-600 leading-relaxed">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>



      {/* فريق العمل */}
      <div 
        data-section="team"
        className="py-12 sm:py-20 bg-gradient-to-br from-[#0a3a23]/5 to-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.team ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23]/20 to-[#0a3a23]/10 text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
              <Users className="w-4 h-4 sm:w-5 sm:h-5" />
              فريق العمل
            </div>
            

            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              نعتز بفريقنا المكون من نخبة من المحامين والمستشارين القانونيين، ذوي المؤهلات الأكاديمية العالية والخبرات المهنية المتنوعة.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* النص */}
            <div className={`transition-all duration-1000 ${visibleSections.team ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="space-y-6 sm:space-y-8">
                <div className="bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl p-6 sm:p-8 border border-[#0a3a23]/20">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri flex items-center gap-3">
                    <Users className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                    خبراء القانون
                  </h3>
                  <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                    يضم فريقنا نخبة من المحامين والمستشارين القانونيين المؤهلين أكاديمياً والمتمرسين مهنياً في مختلف التخصصات القانونية.
                  </p>
                  <ul className="space-y-2 sm:space-y-3">
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      خبرة تراكمية تجاوزت 12 عام
                    </li>
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      مؤهلات أكاديمية عالية
                    </li>
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      تخصصات قانونية متنوعة
                    </li>
                    <li className="flex items-center gap-2 text-sm sm:text-base text-gray-700">
                      <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a3a23]" />
                      التزام بأعلى معايير الجودة
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* الصورة */}
            <div className={`relative transition-all duration-1000 delay-300 ${visibleSections.team ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="relative">
                <img 
                  src="/images/صور الموقع (1)/41.jpg" 
                  alt="فريق العمل - شركة أنس للمحاماة" 
                  className="w-full h-80 sm:h-96 object-cover rounded-2xl sm:rounded-3xl shadow-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a3a23]/30 to-transparent rounded-2xl sm:rounded-3xl"></div>
                
                {/* عناصر عائمة */}
                <div className="absolute -top-4 -right-4 w-8 h-8 sm:w-12 sm:h-12 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-full animate-pulse shadow-lg"></div>
                <div className="absolute -bottom-4 -left-4 w-6 h-6 sm:w-10 sm:h-10 bg-gradient-to-br from-[#0a3a23]/80 to-[#0a3a23]/60 rounded-full animate-bounce shadow-lg" style={{animationDuration: '3s'}}></div>
                
                {/* نص على الصورة */}
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <h4 className="text-lg sm:text-xl font-bold mb-2">فريق قانوني متميز</h4>
                  <p className="text-sm sm:text-base opacity-90">نخبة من المحامين والمستشارين</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Services */}
      <div 
        data-section="services"
        className="py-12 sm:py-20 bg-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.services ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri">
              الخدمات المميزة
            </h2>
            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              نقدم مجموعة شاملة من الخدمات القانونية المتخصصة لتلبية جميع احتياجاتك
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
            {featuredServices.map((service, index) => (
              <div 
                key={service.id} 
                className={`group bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-sm hover:shadow-lg transition-all duration-500 border border-[#0a3a23]/20 hover:border-[#0a3a23]/30 ${visibleSections.services ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <div className="text-center mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#0a3a23]/20 to-[#0a3a23]/10 rounded-xl sm:rounded-2xl flex items-center justify-center mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                    <service.icon className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri">{service.title}</h3>
                </div>
                
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center">
                    {service.description}
                  </p>
                  
                <div className="text-center">
                  <Link
                    to={service.route}
                    className="inline-flex items-center gap-1 sm:gap-2 text-[#0a3a23] hover:text-[#0a3a23]/80 font-semibold transition-colors group text-sm sm:text-base"
                  >
                    <span>اقرأ المزيد</span>
                    <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/Services"
              className="inline-flex items-center gap-2 sm:gap-3 bg-[#0a3a23] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold text-sm sm:text-lg hover:bg-[#0a3a23]/90 transition-all duration-300 shadow-sm"
            >
              <span>عرض جميع الخدمات</span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </Link>
          </div>
        </div>
      </div>

      





      {/* خدمات الدوائر الحكومية */}
      <div className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-amiri">
              خدمات الدوائر الحكومية
            </h2>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-8">
            {governmentLogos.map((logo, index) => (
              <div 
                key={index} 
                className="group p-4 rounded-full bg-white shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <img 
                  src={logo.src} 
                  alt={logo.alt}
                  className="w-24 h-24 object-contain rounded-full group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* المدونات */}
      <div className="py-20 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-amiri">
              المدونات القانونية
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              مقالات مفيدة ومعلومات مهمة
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {blogs.map((blog, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden group"
              >
                <div className="relative">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 right-4 bg-[#0a3a23] text-white px-3 py-1 rounded-full text-sm">
                    {blog.date}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#0a3a23] transition-colors font-amiri">
                    {blog.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {blog.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                      <Clock className="w-4 h-4" />
                      <span>{blog.readTime}</span>
                    </div>
                    <Link
                      to={blog.route}
                      className="inline-flex items-center gap-2 text-[#0a3a23] hover:text-[#0a3a23]/80 font-semibold transition-colors"
                    >
                      <span>اقرأ المزيد</span>
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/Blog"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-8 py-4 rounded-2xl font-bold text-lg hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300"
            >
              <span>عرض جميع المدونات</span>
              <ArrowRight className="w-6 h-6" />
            </Link>
          </div>
        </div>
      </div>

      {/* الأسئلة الشائعة */}
      <div className="py-20 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 bg-white text-[#0a3a23] px-6 py-3 rounded-full text-sm font-medium mb-6 shadow-sm">
              <HelpCircle className="w-5 h-5" />
              الأسئلة الشائعة
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-amiri">
              الأسئلة الشائعة
            </h2>
                          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                إجابات على أكثر الأسئلة شيوعاً
              </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-[#0a3a23]/20 hover:border-[#0a3a23]/30 group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center flex-shrink-0 mt-1 group-hover:scale-110 transition-transform duration-300 shadow-md">
                    <HelpCircle className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-[#0a3a23] transition-colors font-amiri">
                      {faq.question}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-[#0a3a23]/20 max-w-2xl mx-auto">
              <div className="flex items-center justify-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-xl flex items-center justify-center">
                  <WhatsAppIcon className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 font-amiri">هل لديك سؤال آخر؟</h3>
              </div>
              <p className="text-gray-600 mb-6">
                لا تتردد في التواصل معنا للحصول على إجابة شاملة
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Link
                  to="/FAQ"
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-6 py-3 rounded-xl font-semibold text-sm hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300"
                >
                  <span>عرض جميع الأسئلة</span>
                  <ArrowRight className="w-4 h-4" />
                </Link>
                <Link
                  to="/Contact"
                  className="inline-flex items-center gap-2 bg-white text-[#0a3a23] px-6 py-3 rounded-xl font-semibold text-sm hover:bg-[#0a3a23]/10 transition-all duration-300 border border-[#0a3a23]"
                >
                  <WhatsAppIcon className="w-4 h-4" />
                  <span>تواصل معنا</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Testimonials */}
      <div 
        data-section="testimonials"
        className="py-12 sm:py-20 bg-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23]/20 to-[#0a3a23]/10 text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
              <Star className="w-4 h-4 sm:w-5 sm:h-5" />
              تجارب عملائنا
            </div>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri">
              تجارب عملائنا
            </h2>
            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              نفتخر بثقة عملائنا ورضاهم عن الخدمات
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {featuredTestimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id} 
                className={`bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-500 border border-[#0a3a23]/20 hover:border-[#0a3a23]/30 group ${visibleSections.testimonials ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <div className="flex items-center mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300">
                    <span className="text-lg sm:text-xl">{testimonial.platformIcon}</span>
                  </div>
                  <div className="mr-3 sm:mr-4">
                    <h4 className="font-bold text-gray-900 text-sm sm:text-lg group-hover:text-[#0a3a23] transition-colors">{testimonial.platform}</h4>
                  </div>
                </div>
                
                <div className="flex items-center mb-3 sm:mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                
                <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed italic">
                  "{testimonial.content}"
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 sm:mt-12">
            <Link
              to="/Testimonials"
              className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl font-bold text-sm sm:text-lg hover:from-[#0a3a23]/90 hover:to-[#0a3a23]/90 transition-all duration-300 shadow-lg"
            >
              <span>عرض جميع التجارب</span>
              <ArrowRight className="w-4 h-4 sm:w-6 sm:h-6" />
            </Link>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div 
        data-section="contact"
        className="py-12 sm:py-20 bg-gradient-to-br from-[#0a3a23]/5 to-white"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#0a3a23]/20 to-[#0a3a23]/10 text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
              <WhatsAppIcon className="w-4 h-4 sm:w-5 sm:h-5" />
              معلومات التواصل
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-amiri">
              للتواصل معنا
            </h2>
            <p className="text-sm sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-0">
              نحن هنا لمساعدتك في جميع احتياجاتك القانونية
            </p>
          </div>

          {/* معلومات التواصل الرئيسية */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 sm:p-12 mb-8 sm:mb-12 border border-[#0a3a23]/10">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {/* الرقم الموحد */}
              <div className={`group text-center p-6 sm:p-8 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-2xl hover:from-[#0a3a23]/20 hover:to-[#0a3a23]/10 transition-all duration-500 hover:shadow-lg hover:scale-105 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '0ms' }}>
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Phone className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri">الرقم الموحد</h3>
                <a href="tel:920033053" className="text-lg sm:text-xl font-bold text-[#0a3a23] hover:text-[#0a3a23]/80 transition-colors">
                  920033053
                </a>
              </div>

              {/* العنوان */}
              <div className={`group text-center p-6 sm:p-8 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-2xl hover:from-[#0a3a23]/20 hover:to-[#0a3a23]/10 transition-all duration-500 hover:shadow-lg hover:scale-105 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '200ms' }}>
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <MapPin className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri">العنوان</h3>
                <p className="text-sm sm:text-base text-gray-700 font-medium">
                  المملكة العربية السعودية - مدينة جدة - حي المرجان - مركز النايفة -الدور الأول - مكتب رقم 8
                </p>
                
              </div>

              {/* البريد الإلكتروني */}
              <div className={`group text-center p-6 sm:p-8 bg-gradient-to-br from-[#0a3a23]/10 to-[#0a3a23]/5 rounded-2xl hover:from-[#0a3a23]/20 hover:to-[#0a3a23]/10 transition-all duration-500 hover:shadow-lg hover:scale-105 ${visibleSections.contact ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ transitionDelay: '400ms' }}>
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <Mail className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 font-amiri">البريد الإلكتروني</h3>
                <a href="mailto:info@khayat.sa" className="text-sm sm:text-base font-bold text-[#0a3a23] hover:text-[#0a3a23]/80 transition-colors break-all">
                  info@khayat.sa
                </a>
              </div>


            </div>
          </div>


        </div>
      </div>

      {/* Floating Contact Button */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href={`${whatsappUrl}?text=أريد استشارة قانونية`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Custom CSS for animations */}
      <style jsx>{`
        @keyframes blob {
          0% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          100% {
            transform: translate(0px, 0px) scale(1);
          }
        }
        @keyframes spin-slow {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        .animation-delay-1000 {
          animation-delay: 1s;
        }
      `}</style>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage; 
